import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const useCommonAPI = () => {
  const { send } = useFetchData()

  const getWorkers = async (params, include_count=0) => {
    params = params ?? {}

    const body = await send({
      method: "GET",
      url: `${apiUrl}/common/workers`,
      params: {
        "search": params["search"] ?? "",
        "offset": params["offset"] ?? "",
        "limit": params["limit"] ?? "",
        "include_count": include_count
      },
      returnType: "json"
    })

    return body
  }

  return { getWorkers }
}

export default useCommonAPI
